// extracted by mini-css-extract-plugin
export var container = "_eo-1";
export var cornerButtonContainer = "_eo-6";
export var disabled = "_eo-2";
export var dragActive = "_eo-3";
export var fileContainer = "_eo-5";
export var hiddenInput = "_eo-4";
export var widthContainer = "_eo-0";